var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[(!_vm.isMobile)?_c('div',{staticClass:"pc"},[_c('cover',{staticClass:"home-cover"}),_c('router-view',{staticClass:"home-view"})],1):_c('div',{staticClass:"mobile"},[_c('router-view')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }